
export class LOVRegistrationApprovalStatusExtension {
}
